// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.audit-modal[data-v-0bedfacf] {\n  min-height: 150px !important;\n}\n", ""]);
// Exports
module.exports = exports;
